import React from 'react';
import { motion } from 'framer-motion';
import { Send, Star, ShieldCheck } from 'lucide-react';
import { Button } from './Button';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  show: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: i * 0.1,
      ease: [0.22, 1, 0.36, 1] as const
    }
  })
};
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-navy-900" data-id="element-80" data-mp="9ouf3tkq2n0r">
      {/* ambient glow */}
      <div className="pointer-events-none absolute -top-32 left-1/2 h-96 w-[46rem] -translate-x-1/2 rounded-full bg-brand-blue/20 blur-[120px]" data-id="element-81" data-mp="17c2wpdhlrbxh" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-80 w-80 rounded-full bg-brand-cyan/15 blur-[110px]" data-id="element-82" data-mp="xjezwiqmh7yr" />

      <div className="relative mx-auto flex min-h-[520px] max-w-4xl flex-col items-center justify-center px-4 py-20 text-center sm:px-6 lg:py-28" data-id="element-83" data-mp="sku8n8tclymg">
        <motion.p variants={fadeUp} initial="hidden" animate="show" custom={0} className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-brand-cyan" data-id="element-84" data-mp="1laaxxxlo8zeg">
          — Unlock Pure, Toxin-Free Water —
        </motion.p>

        <motion.h1 variants={fadeUp} initial="hidden" animate="show" custom={1} className="font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-85" data-mp="39rgtf50sqi33">
          The Best Water at{' '}
          <span className="text-brand-cyan" data-id="element-86" data-mp="2zvm63wlmnytz">The Best Price</span>{' '}
          in Tulsa
        </motion.h1>

        <motion.p variants={fadeUp} initial="hidden" animate="show" custom={2} className="mt-6 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-87" data-mp="2qskzlusuo5ps">
          As a family-owned business, Tulsa Water Pros systems effectively remove harmful
          toxins and hardness from your entire home&apos;s water supply — for softer skin,
          spotless dishes, and crisp, great-tasting water.
        </motion.p>

        <motion.div variants={fadeUp} initial="hidden" animate="show" custom={3} className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-88" data-mp="rmz3pwzfspme">
          <Button as="a" href="#quote" variant="primary" data-id="element-89" data-mp="imsu4m6v09si">
            <Send className="h-4 w-4" data-id="element-90" data-mp="dn6gwcr16tjp" />
            Get a Free Quote
          </Button>
          <Button as="a" href="#how" variant="outline" data-id="element-91" data-mp="1b8lruhdasy8f">
            Learn More
          </Button>
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" animate="show" custom={4} className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-92" data-mp="16b2d7gcoujfy">
          <span className="inline-flex items-center gap-2" data-id="element-93" data-mp="1u04tajroc48c">
            <span className="flex" data-id="element-94" data-mp="1u1pqkh5di19w">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-95" data-mp="1p7tvpnkeouiy" data-mpi={i} />)}
            </span>
            100+ 5-Star Reviews
          </span>
          <span className="inline-flex items-center gap-2" data-id="element-96" data-mp="21iujyu2phaib">
            <ShieldCheck className="h-4 w-4 text-brand-cyan" data-id="element-97" data-mp="21lh2for4xafb" />
            Lifetime Warranty
          </span>
        </motion.div>
      </div>
    </section>;
}